import React from 'react';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const CheckIcon = ({ toolTipText }) => (
  <Icon tooltip={toolTipText} iconObj={faCheck} />
);

export default CheckIcon;